import React from 'react';

function CalendarIcon({ w, h, style, fill, className }) {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}`}
      height={`${h}`}
      viewBox="0 0 16 16"
      style={style}
    >
      <g fill={fill}>
        <path
          d="M11.33 8H8v3.33h3.33V8zM10.67.67V2H5.33V.67H4V2h-.67c-.74 0-1.32.6-1.32 1.33L2 12.67C2 13.4 2.6 14 3.33 14h9.34c.73 0 1.33-.6 1.33-1.33V3.33C14 2.6 13.4 2 12.67 2H12V.67h-1.33zm2 12H3.33V5.33h9.34v7.34z"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

CalendarIcon.defaultProps = {
  w: 24,
  h: 24,
  style: {},
  fill: '#888',
};

export default CalendarIcon;
